import React from 'react';
import './AboutPAPT.css';  // Import the corresponding CSS file for styling

const AboutPAPT = () => {
  return (
    <div className="about-container">
      <div className="content">
        <h1>PAPT</h1>
        <div className="yellow-line1"></div>
        <p>
          P.A Polytechnic is a premier educational institution, established in the year 2006, to provide career-oriented quality technical education and to produce technically competent engineers enriched with moral and ethical values. The college offers three-year Diploma programs in Mechanical Engineering, Civil Engineering, Electrical & Electronics Engineering, Electronics & Communications Engineering, and Computer Science Engineering. In a span of over 19 years, the college has earned the recognition as an institution of repute and has now emerged as one of the most preferred educational destinations for technical education in coastal Karnataka. To meet the growing demand for diploma in engineering courses, the total intake of the institute has been elevated from 300 to 540. The institution regularly conducts Technical seminars and workshops by inviting eminent personalities from industry and academia to enhance the technical knowledge and skills of the students.
          P.A. Polytechnic is approved by All India Council for Technical Education, New Delhi, and affiliated with the Board of Technical Education, Bangalore. The college is located in Mangalore, a beautiful city, which has earned itself the reputation as the Knowledge Hub of South India. The college is idealistically located in the midst of pristine nature in a lush green campus spread across 60 acres. The calm and pleasant atmosphere sets the perfect stage for imparting unmatched quality education blended with moral and ethical values.
        </p>

       
      </div>
      <div className="ed">
        <img src="/images/poly.png" alt="P.A. Polytechnic" />
      </div>
    </div>
  );
};

export default AboutPAPT;
